import Vuex from 'vuex';
import tokenHelper from "@/helpers/token_helper"

export default Vuex.createStore({
  state: {
    userInfo: "",//用户信息
    UserPosition:"",//用户位置
    homeRouter:"",//首页tab状态
    chargeId:"",//充电桩号
    invoicesData:"",//用户开票信息
    token:tokenHelper.readAccessToken()
  },
  mutations: { 
    setUser(state, data) {
      state.userInfo = data;
    },
    clearUser(state) {
      state.userInfo = "";
    },
    setPosition(state, data){
      state.UserPosition = data;
    },
    setHomeRouter(state, data){
      state.homeRouter = data
    },
    setChargeId(state, data){
      state.chargeId = data
    },
    clearHomeRouter(state){
      state.homeRouter = "home"
    },
    setInvoices(state, data){
      state.invoicesData = data
    },
    clearInvoices(state){
      state.invoices = ""
    }
  },
  actions: {},
  modules: {},
});
